function includesExtension(extensions, name) {
  var dotIndex = name.lastIndexOf('.');
  var extension = name.substring(dotIndex + 1).toLocaleLowerCase();
  return extensions.includes(extension);
}
export var webViewerClientSupported = ['pdf', 'xfdf', 'fdf', 'docx', 'xlsx', 'pptx', 'jpg', 'jpeg', 'png', 'jfif', 'xls'];
export var isWebViewerClientSupported = includesExtension.bind(null, webViewerClientSupported);
export var webViewerServerSupported = ['doc', 'xls', 'ppt', 'pub', 'dwg', 'dxf', 'dgn', 'rvt', 'bmp', 'wmf', 'emf', 'gif', 'jp2', 'jpc', 'rtf', 'html', 'msg', 'eml', 'txt', 'xps', 'xod', 'xaml'];
export var isWebViewerServerSupported = includesExtension.bind(null, webViewerServerSupported);
